/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/

import { of } from "rxjs";
import { MyInjector } from "@src/app/app.module";
import { Unit } from "@src/app/model/unit";
import { ActionColor } from "@src/app/shared/form/form.component";
import { IFormAction } from "@src/app/shared/form/form.component";
import { Router } from "@angular/router";
import { MyUnitPageNavRoute } from "@src/app/routes/app-router";


export class UnitExternalViewAction implements IFormAction {
    name = $localize`External View of this unit`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'visibility';
    approvalNeeded = false;
    disabled = false;
    approvalText = '';
    tipText: string = $localize `Look at this unit displayed as it would be to the owner if they login to the system to view their unit details.`;
    unit: Unit;

    router = MyInjector.instance.get(Router);

    action() {
        this.router.navigate([MyUnitPageNavRoute.getIdUrl(this.unit.id)])
        return of(this.unit)
    }

    setup(unit: Unit) {
        this.unit = unit;
        this.show = true;
    }
}
